import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { comma, uncomma, useFormInput } from "@/utils";
import { Confirm, Loading, Toast } from "@/components";
import { ImageUpload } from "@/components/Common/ImageUpload";
import SearchAddress from "@/components/Modal/Common/SearchAddress";
import {
    ContractInfo,
    AccidentInfo,
    // VehicleInfo,
    // DriverInfo,
    // AdditionalDriverInfo,
    OtherInfo,
    OtherEtcInfo,
    EtcInfo,
    InsuranceDeliveredInfo,
    InsuranceInfo,
    InsuranceTable,
    InsuranceInfoNormal,
    InsuranceInfoCar,
    InsuranceInfoTotal,
    // ReturnInfo,
    BusinessInfo,
    CapitalInfo,
    BillingInfo,
    TotalBillingInfo,
    TermsTable,
    TermsFile,
    AttachedFile,
} from "./components";
import { DriverInfo, AdditionalDriverInfo, VehicleInfo, ReturnInfo } from "./_components";
import {
    AgentPartnersPopup,
    SalesPartnersPopup,
    OrderListPopup,
    VehicleListPopup,
    TermListPopup,
    VehicleReturnPopup,
    BillingSettingPopup,
    InsuranceConfigPopup,
} from "./popups";

import { useLazyGetCarByIdQuery, useLazySearchCarByNumberQuery } from "@/redux/carApi";
import { useGetOrderDetailMutation } from "@/redux/orderApi";
import { usePostChargeMutation, usePostPreChargeMutation } from "@/redux/chargeApi";
import { useUploadFileMutation } from "@/redux/uploadApi";
import {
    useDeleteContractGroupMutation,
    useGetContractGroupByIdQuery,
    usePostContractGroupMutation,
    usePutContractGroupMutation,
    useReturnContractMutation,
    useUpdateContractGroupExposedYnMutation,
    useGetContractGroupListQuery,
} from "@/redux/contractApi";
import { useGetTermListQuery } from "@/redux/termApi";
import { useGetInsuranceConfigDetailQuery, useGetInsuranceConfigListQuery, useLazyGetRentCorpByCarIdQuery } from "@/redux/rentCorpApi";
import { skipToken } from "@reduxjs/toolkit/query";
import { convertUTCToLocal } from "../../utils";

// 초기 계약서 객체
const initialContract = {
    rentCorpId: null,
    carId: null,
    contractCar: {
        carNumber: "",
        cho: "",
        manufacturerName: "",
        modelName: "",
        modelDetailName: "",
        className: "",
        trimName: "",
        bmNo: "",
        boiNo: "",
        boNo: "",
        bsNo: "",
        bdNo: "",
        firstDate: "",
        color: "",
        fuel: "",
        motorType: "",
        displacement: 0,
        mileage: 0,
        gasCurrentAmount: 0,
    },
    // insuranceItems: [
    //     {
    //         insuranceItemType: "DAEIN_PAY_1", // 대인배상1
    //         joinYn: "Y",
    //         limitType: "LAW_MAX",
    //         compensationRange: null,
    //         selfPay: 30000,
    //     },
    //     {
    //         insuranceItemType: "DAEIN_PAY_2", // 대인배상2
    //         joinYn: "Y",
    //         limitType: null,
    //         compensationRange: -1,
    //         selfPay: 30000,
    //     },
    //     {
    //         insuranceItemType: "DAEMUL_PAY", // 대물배상
    //         joinYn: "Y",
    //         limitType: null,
    //         compensationRange: 100000000,
    //         selfPay: 0,
    //     },
    //     {
    //         insuranceItemType: "NO_INS_INJURY", // 무보험차상해
    //         joinYn: "N",
    //         limitType: null,
    //         compensationRange: null,
    //         selfPay: null,
    //     },
    //     {
    //         insuranceItemType: "JASON_DEAD", // 자동차상해(사망)
    //         joinYn: "Y",
    //         limitType: null,
    //         compensationRange: 10000000,
    //         selfPay: 30000,
    //     },
    //     {
    //         insuranceItemType: "JASON_INJURY", // 자동차상해(부상)
    //         joinYn: "Y",
    //         limitType: null,
    //         compensationRange: 10000000,
    //         selfPay: 30000,
    //     },
    //     {
    //         insuranceItemType: "JASON_BLOCK", // 자동차상해(장해)
    //         joinYn: "Y",
    //         limitType: null,
    //         compensationRange: 10000000,
    //         selfPay: 30000,
    //     },
    //     {
    //         insuranceItemType: "SELF_CAR_DAMAGE", // 자기차량손해
    //         joinYn: "Y",
    //         limitType: null,
    //         compensationRange: 30000000,
    //         selfPay: 50000,
    //         selfCarDamageRangeType: "PRICE", // "PRICE" or "RATE" 선택값
    //         selfCarDamageRateType: null,
    //     },
    //     {
    //         insuranceItemType: "EMERGENCY_SERVICE", // 긴급출동
    //         joinYn: "N",
    //         limitType: null,
    //         compensationRange: null,
    //         selfPay: null,
    //     },
    // ],
    contractInsuranceCondition: {
        id: null,
        applicableAge: 21, // 기본값: 만 21세 이상
        selfCarIndemnityPrice: null, // 기본값: 없음
        selfCarLimitValue: 30000000, // 기본값: 3천만원
        selfCarLimitType: "PRICE", // 기본값: 금액
        bodilyInjuryLimitPrice: -1, // 기본값: 무한
        propertyDamageLimitPrice: 100000000, // 기본값: 1억원
        personalInjuryLimitInjury: 15000000, // 기본값: 1천5백만원
        personalInjuryLimitDeath: 15000000, // 기본값: 1천5백만원
        bodilyInjuryDeductible: null, // 기본값: 없음
        propertyDamageDeductible: null, // 기본값: 없음
        personalInjuryDeductible: null, // 기본값: 없음
    },
    contractDrivers: [
        {
            contractDriverType: "MAIN",
            name: "",
            idNumber: "",
            phone: "",
            address: "",
            addressDetail: "",
            driverLicenseType: null,
            driverLicenseNumber: "",
            serialNumber: "",
            issueDate: "",
        },
    ],
    additionalDriverStatus: false,
};

export const ContractRegister = () => {
    const { contractGroupId } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const passedCarId = location.state?.carId;
    const passedOrderId = location.state?.orderId;
    const passedOrder = location.state?.order;

    const { formData, handleChange, setFormData } = useFormInput({
        // 공통
        mode: "CREATE", // "CREATE" / "READ" / "UPDATE"
        toastMsg: "",
        confirmStatus: {
            confirmPopupStatus: false,
            confirmTitle: "",
            confirmDescription: "",
            confirmButtons: [],
            showCheckbox: false,
            checkboxLabel: "",
        },
        servicePopupStatus: false,
        addressPopupStatus: false,
        addressPopupTarget: null, // "MAIN" | "ADDITIONAL" | "ALLOCATION_RELEASE" | "ALLOCATION_RETURN" | "BUSINESS"
        agentPartnersPopupStatus: false,
        salesPartnersPopupStatus: false,
        vehicleListPopupStatus: false,
        vehicleReturnPopupStatus: false,
        vehicleReturnContractIdx: null,
        billingSettingPopupStatus: false,
        termSelectPopupStatus: false,
        orderListPopupStatus: false,
        id: null, // contractGroupId
        businessStatus: false,
        contractType: "",
        memoForClient: "",
        memoForContract: "",
        memoForInsCorp: "",
        contractUploads: [],
        contractTerms: [],
        driverLicenseFileName: "",
        driverLicense2FileName: "",
        bizLicenseFileName: "",
        etcFileName: "",
        addFileName: "",
        addTermFileName: "",
        contracts: [{ ...initialContract }],
        faxFileUploadId: undefined,
        faxFileUrl: undefined,
        passedOrderId: passedOrderId,
        contractInsurance: {
            chargeRate: 65,
        },
        passedOrder: passedOrder,
    });
    const {
        mode,
        toastMsg,
        confirmStatus,
        addressPopupStatus,
        agentPartnersPopupStatus,
        salesPartnersPopupStatus,
        vehicleReturnPopupStatus,
        billingSettingPopupStatus,
        isLoading,
    } = formData;
    const [selectedContractIndex, setSelectedContractIndex] = useState(0); // 선택한 계약서 인덱스
    const [insuranceConfigPopupStatus, setInsuranceConfigPopupStatus] = useState(false);
    const [selectedInsuranceConfigId, setSelectedInsuranceConfigId] = useState(null);

    const [postContractGroup, { data: postData, isLoading: isPostLoading, error: isPostError }] = usePostContractGroupMutation();
    const [putContractGroup, { data: putData, isLoading: isPutLoading, error: isPutError }] = usePutContractGroupMutation();
    const [deleteContractGroup, { isLoading: isDeleteLoading }] = useDeleteContractGroupMutation();
    const [uploadFile, { isLoading: isFileUploading }] = useUploadFileMutation();
    const [doSearchCar, { data: searchCarData, isSearchLoading, isSearchError }] = useLazySearchCarByNumberQuery();
    const [getCarById, { isLoading: carLoading, error: carError }] = useLazyGetCarByIdQuery();
    const [fetchRentCorpByCarId, { isLoading: isRentCorpLoading }] = useLazyGetRentCorpByCarIdQuery();
    const [postCharge] = usePostChargeMutation();
    const [postPreCharge] = usePostPreChargeMutation();
    const [getOrderDetail, { data: detailData, isLoading: detailIsLoading, error: detailError }] = useGetOrderDetailMutation();
    const [returnContract, { isLoading: isReturnLoading }] = useReturnContractMutation();
    const {
        data: contractGroupData,
        isLoading: isContractGroupLoading,
        isFetching: isContractGroupFetching,
        error: contractGroupError,
    } = useGetContractGroupByIdQuery(contractGroupId, {
        skip: !contractGroupId,
        refetchOnMountOrArgChange: true,
    });
    const [updateContractGroupExposedYn] = useUpdateContractGroupExposedYnMutation();

    // 오더 ID로 계약 그룹 리스트 조회
    const { data: contractGroupsForOrder, isLoading: isContractGroupsForOrderLoading } = useGetContractGroupListQuery(
        { order_id: passedOrderId },
        { skip: !passedOrderId || mode !== "CREATE" }
    );

    const [existingContractGroups, setExistingContractGroups] = useState([]);

    // 오더 ID로 생성된 기존 계약서 확인
    useEffect(() => {
        console.log(contractGroupsForOrder);
        if (contractGroupsForOrder && contractGroupsForOrder.data && contractGroupsForOrder.data.length > 0) {
            setExistingContractGroups(contractGroupsForOrder.data);
            setFormData((prev) => ({
                ...prev,
                toastMsg: "해당 오더로 생성된 계약서가 이미 존재합니다.",
                passedOrderId: passedOrderId,
            }));
        }
    }, [contractGroupsForOrder, setFormData]);

    useEffect(() => {
        console.log(formData);
    }, [formData]);

    // 보험 설정 목록 조회
    const { data: insuranceConfigList } = useGetInsuranceConfigListQuery(formData.contracts[selectedContractIndex]?.rentCorpId, {
        skip: !formData.contracts[selectedContractIndex]?.rentCorpId,
    });

    // 보험 설정 상세 조회
    const { data: insuranceConfigDetail } = useGetInsuranceConfigDetailQuery(
        {
            rentCorpId: formData.contracts[selectedContractIndex]?.rentCorpId,
            insuranceConfigId: selectedInsuranceConfigId,
        },
        {
            skip: !formData.contracts[selectedContractIndex]?.rentCorpId || !selectedInsuranceConfigId,
        }
    );

    // 보험 설정 상세 조회 결과 처리
    useEffect(() => {
        if (insuranceConfigDetail?.data) {
            const processedInsuranceItems = insuranceConfigDetail.data.insuranceConfigItems.map((item) => ({
                id: item.id,
                insuranceItemType: item.insuranceItemType,
                joinYn: item.joinYn,
                limitType: item.limitType,
                selfCarDamageRangeType: item.selfCarDamageRangeType,
                selfCarDamageRateType: item.selfCarDamageRateType,
                compensationRange: item.compensationRange,
                selfPay: item.selfPay,
            }));

            setFormData((prev) => {
                const newContracts = [...prev.contracts];

                newContracts[selectedContractIndex] = {
                    ...newContracts[selectedContractIndex],
                    insuranceItems: processedInsuranceItems,
                };

                const result = {
                    ...prev,
                    contracts: newContracts,
                };
                return result;
            });
            setInsuranceConfigPopupStatus(false);
        }
    }, [insuranceConfigDetail, selectedContractIndex, setFormData]);

    const handleInsuranceConfigLoad = () => {
        setInsuranceConfigPopupStatus(true);
    };

    // ─────────────────────────────────────────────────────────────────────────
    // 1) 모드 설정 (UPDATE / CREATE)
    // ─────────────────────────────────────────────────────────────────────────
    useEffect(() => {
        if (contractGroupId) {
            setFormData((prev) => ({
                ...prev,
                mode: "UPDATE",
                id: contractGroupId,
            }));
        } else {
            setFormData((prev) => ({
                ...prev,
                mode: "CREATE",
            }));
        }
    }, [contractGroupId, setFormData]);

    // ─────────────────────────────────────────────────────────────────────────
    // 2) UPDATE 모드일 때: 계약 상세조회 (contractDetailData) 매핑
    // ─────────────────────────────────────────────────────────────────────────
    useEffect(() => {
        // CREATE 모드일 때 early return
        if (!contractGroupId) return;

        if (contractGroupData && contractGroupData.data) {
            const response = contractGroupData.data;
            // contractDrivers 변환: idNumber 분리 및 driverLicenseNumber 처리
            const mappedContractDrivers = (response.contractDrivers || []).map((driver) => {
                let updatedDriver = { ...driver };
                // idNumber 분리: 앞 6자리와 뒷 7자리
                if (updatedDriver.idNumber && updatedDriver.idNumber.length >= 7) {
                    updatedDriver.idNumberF = updatedDriver.idNumber.slice(0, 6);
                    updatedDriver.idNumberB = updatedDriver.idNumber.slice(6); // 뒷 7자리 모두 처리
                }
                // driverLicenseNumber 분리: 앞 2자리를 Number 타입의 localCode로 저장하고, 나머지 문자열 재설정
                if (updatedDriver.driverLicenseNumber && updatedDriver.driverLicenseNumber.length >= 2) {
                    updatedDriver.localCode = Number(updatedDriver.driverLicenseNumber.slice(0, 2));
                    updatedDriver.driverLicenseNumber = updatedDriver.driverLicenseNumber.slice(2);
                }
                return updatedDriver;
            });
            // 제2 운전자가 있으면 additionalDriverStatus를 true로 설정
            const additionalDriverExists = mappedContractDrivers.some((driver) => driver.contractDriverType === "ADDITIONAL");
            // contractBusinessInfo가 존재하면 businessStatus를 true로 설정
            const businessStatus = response.contractBusinessInfo ? true : false;

            // contracts 배열 매핑 (contractInsuranceCondition 포함)
            const mappedContracts = (response.contracts || []).map((contract) => ({
                ...contract,
                // 기존 insuranceItems가 없거나 빈 배열이면 contractInsuranceCondition 초기값 설정
                contractInsuranceCondition: contract.contractInsuranceCondition || {
                    id: null,
                    applicableAge: 21,
                    selfCarIndemnityPrice: null,
                    selfCarLimitValue: 30000000,
                    selfCarLimitType: "PRICE",
                    bodilyInjuryLimitPrice: -1,
                    propertyDamageLimitPrice: 100000000,
                    personalInjuryLimitInjury: 15000000,
                    personalInjuryLimitDeath: 15000000,
                    bodilyInjuryDeductible: null,
                    propertyDamageDeductible: null,
                    personalInjuryDeductible: null,
                },
            }));

            setFormData((prev) => ({
                ...prev,
                isLoading: false,
                ...response,
                // contractDrivers 변환 결과 반영
                contractDrivers: mappedContractDrivers,
                additionalDriverStatus: additionalDriverExists,
                businessStatus: businessStatus,
                faxFileUploadId: response.charge?.faxFileUploadId || undefined,
                faxFileUrl: response.charge?.faxFileUrl || undefined,
                // contracts 배열 매핑 결과 반영
                contracts: mappedContracts,
                // 필요시 contractCar 등 다른 필드도 추가 매핑
            }));
        }
    }, [contractGroupId, contractGroupData, setFormData]);

    // ─────────────────────────────────────────────────────────────────────────
    // 3) CREATE 모드일 때: passedCarId 또는 passedOrderId 처리
    // ─────────────────────────────────────────────────────────────────────────
    // 3-1) passedCarId가 있으면 차량 조회
    useEffect(() => {
        if (!contractGroupId && passedCarId) {
            // passedCarId가 존재하면 handleSearchCar() 로직 실행
            // (handleSearchCar 내부에서 doSearchCar 호출 → formData에 세팅)
            handleSearchCar(passedCarId);
        }
    }, [contractGroupId, passedCarId]);

    // 3-2) passedOrderId가 있으면 오더 상세조회 → formData에 세팅
    const loadOrderDetail = async (orderId) => {
        try {
            const res = await getOrderDetail(orderId).unwrap();
            const response = res.data;
            console.log("오더 ID 정보");
            console.log(response);
            setFormData((prev) => ({
                ...prev,
                isLoading: false,
                orderId: orderId,
                platformCommissionRate: response?.platformCommissionRate,
                contractType: response?.orderType,
                accidentCar: {
                    ...response?.accidentCar,
                    bdNo: response?.bdNo,
                    bmNo: response?.bmNo,
                    boNo: response?.boNo,
                    boiNo: response?.boiNo,
                    bsNo: response?.bsNo,
                    carGubun: response?.carGubun,
                    carNumber: response?.carNumber,
                    cho: response?.cho,
                    className: response?.className,
                    displacement: comma(response?.displacement),
                    manufacturerName: response?.manufacturerName,
                    modelDetailName: response?.modelDetailName,
                    modelName: response?.modelName,
                    trimName: response?.trimName,
                },
                customerName: response?.orderCustomer?.name,
                customerPhone: response?.orderCustomer?.phone,
                contractInsurance: {
                    ...response?.contractInsurance,
                    id: response?.orderInsurance.id,
                    chargeMethod:
                        response?.orderInsurance?.chargeMethod === "RENT_PRICE"
                            ? response?.orderInsurance?.rentPriceTableId
                            : response?.orderInsurance?.chargeMethod,
                    chargeRate: response?.orderInsurance?.chargeRate,
                    insuranceCorpId: response?.orderInsurance?.insuranceCorpId,
                    insuranceCorpName: response?.orderInsurance.insuranceCorpName,
                    receiptNumber: response?.orderInsurance.receiptNumber,
                    managerName: response?.orderInsurance.managerName,
                    managerPhone: response?.orderInsurance.managerPhone,
                    faxNumber: response?.orderInsurance.faxNumber,
                    email: response?.orderInsurance.email,
                    prefixNumber: response?.orderInsurance?.prefixNumber,
                    receiptAddNumber: response?.orderInsurance?.receiptAddNumber,
                },
                contractMechanic: {
                    ...response?.contractMechanic,
                    mechanicCorpName: response?.orderMechanic?.mechanicCorpName,
                    phone: response?.orderMechanic?.phone,
                },
                contracts: prev.contracts.map((ct) => ({
                    ...ct,
                    contractCar: {
                        ...ct.contractCar,
                    },
                    // 오더콜 계약이므로 자차면책금 기본값 30만원 설정
                    contractInsuranceCondition: {
                        ...ct.contractInsuranceCondition,
                        selfCarIndemnityPrice: 300000, // 30만원 기본값
                    },
                    contractDrivers: ct.contractDrivers
                        ? ct.contractDrivers.map((driver) =>
                            driver.contractDriverType === "MAIN"
                                ? {
                                    ...driver,
                                    name: response?.orderCustomer?.name,
                                    phone: response?.orderCustomer?.phone,
                                    idNumberF: response?.orderCustomer?.birthDate?.replace(/-/g, "").slice(2, 8),
                                }
                                : driver
                        )
                        : ct.contractDrivers,
                })),
            }));
        } catch (err) {
            console.error("오더 상세 조회 에러:", err);
        }
    };

    useEffect(() => {
        if (formData.mode === "CREATE") {
            if (!contractGroupId && passedOrderId) {
                // passedOrderId가 존재하면 getOrderDetail API 호출
                loadOrderDetail(passedOrderId);
            } else if (contractGroupId && formData.orderId) {
                loadOrderDetail(formData.orderId);
            }
        }
    }, [formData.orderId, contractGroupId, passedOrderId, getOrderDetail, setFormData, formData.mode]);

    const handleSelectCar = () => {
        setFormData((prev) => ({ ...prev, vehicleListPopupStatus: true }));
    };

    // 전달받은 차량번호가 있으면 자동으로 formData에 세팅하고 handleSearchCar 호출
    useEffect(() => {
        if (passedCarId) {
            setFormData((prev) => ({
                ...prev,
                contractCar: { ...prev.contractCar, id: passedCarId },
            }));
            handleSearchCar(passedCarId);
        }
    }, [passedCarId]);

    useEffect(() => {
        setFormData((prev) => {
            const updatedContracts = [...prev.contracts];
            const contract = updatedContracts[selectedContractIndex];

            if (prev.additionalDriverStatus) {
                // 추가 운전자가 없으면 추가
                if (!contract.contractDrivers.some((d) => d.contractDriverType === "ADDITIONAL")) {
                    contract.contractDrivers.push({
                        contractDriverType: "ADDITIONAL",
                        name: "",
                        idNumber: "",
                        phone: "",
                        address: "",
                        addressDetail: "",
                        bCode: "",
                        driverLicenseType: "",
                        driverLicenseNumber: "",
                        serialNumber: "",
                        issueDate: "",
                    });
                }
            } else {
                // 추가 운전자 제거
                const hasAdditionalDriver = contract?.contractDrivers?.some((d) => d.contractDriverType === "ADDITIONAL");
                if (hasAdditionalDriver) {
                    contract.contractDrivers = contract?.contractDrivers?.filter((d) => d.contractDriverType !== "ADDITIONAL");
                }
            }

            return {
                ...prev,
                contracts: updatedContracts,
            };
        });
    }, [formData.additionalDriverStatus, selectedContractIndex, setFormData]);

    // buildRequestBody – 그룹 레벨 필드와 contracts 배열 포함
    const buildRequestBody = () => {
        let reqBody = { ...formData };

        // UI용 상태 값들 제거
        delete reqBody.mode;
        delete reqBody.toastMsg;
        delete reqBody.confirmStatus;
        delete reqBody.servicePopupStatus;
        delete reqBody.id;
        delete reqBody.additionalDriverStatus;
        delete reqBody.businessStatus;
        delete reqBody.driverLicenseFileName;
        delete reqBody.driverLicense2FileName;
        delete reqBody.bizLicenseFileName;
        delete reqBody.etcFileName;
        delete reqBody.addFileName;
        delete reqBody.addTermFileName;
        delete reqBody.vehicleReturnPopupStatus;
        delete reqBody.billingSettingPopupStatus;
        delete reqBody.addressPopupStatus;
        delete reqBody.addressPopupTarget;
        delete reqBody.agentPartnersPopupStatus;
        delete reqBody.salesPartnersPopupStatus;
        delete reqBody.vehicleListPopupStatus;

        // accidentCar.displacement가 문자열로 콤마 포함 시 uncomma 처리
        if (reqBody.accidentCar && typeof reqBody.accidentCar.displacement === "string") {
            reqBody.accidentCar.displacement = Number(uncomma(reqBody.accidentCar.displacement));
        }

        // contracts 배열 내 각 계약서의 contractCar 필드 처리
        if (Array.isArray(reqBody.contracts)) {
            reqBody.contracts = reqBody.contracts.map((contract) => {
                const updatedContract = { ...contract };

                // contractCar 처리
                if (updatedContract?.contractCar) {
                    if (typeof updatedContract.contractCar.displacement === "string") {
                        updatedContract.contractCar.displacement = Number(uncomma(updatedContract.contractCar.displacement));
                    }
                    if (typeof updatedContract.contractCar.mileage === "string") {
                        updatedContract.contractCar.mileage = Number(uncomma(updatedContract.contractCar.mileage));
                    }
                }

                // contractDrivers 처리
                if (Array.isArray(updatedContract.contractDrivers)) {
                    updatedContract.contractDrivers = updatedContract.contractDrivers.map((driver) => {
                        const updatedDriver = { ...driver };
                        // 주민등록번호 idNumberF + idNumberB
                        if (updatedDriver.idNumberF !== undefined && updatedDriver.idNumberB !== undefined) {
                            updatedDriver.idNumber = updatedDriver.idNumberF + updatedDriver.idNumberB;
                        }
                        // 면허번호 localCode + driverLicenseNumber 재설정
                        if (updatedDriver.localCode && updatedDriver.driverLicenseNumber) {
                            updatedDriver.driverLicenseNumber = String(updatedDriver.localCode) + updatedDriver.driverLicenseNumber;
                        }
                        // driverLicenseType 빈 문자열이면 null로 변환
                        return {
                            ...updatedDriver,
                            driverLicenseType: updatedDriver.driverLicenseType === "" ? null : updatedDriver.driverLicenseType,
                        };
                    });
                }

                // contractInsuranceCondition 처리 (신규 보험 정보 구조)
                if (updatedContract?.contractInsuranceCondition) {
                    const condition = updatedContract.contractInsuranceCondition;

                    // 10억 미만 검증 함수 (999,999,900원 = 99,999만원)
                    const validateAmountRange = (value, fieldName) => {
                        if (value !== null && value !== undefined && Math.abs(value) >= 1000000000) {
                            console.warn(`${fieldName} 값이 10억원을 초과합니다: ${value}`);

                            // 필드명을 한국어로 변환
                            let koreanFieldName = "";
                            switch (fieldName) {
                                case "selfCarIndemnityPrice": koreanFieldName = "자차면책금"; break;
                                case "bodilyInjuryLimitPrice": koreanFieldName = "대인한도"; break;
                                case "propertyDamageLimitPrice": koreanFieldName = "대물한도"; break;
                                case "personalInjuryLimitInjury": koreanFieldName = "자손한도(부상)"; break;
                                case "personalInjuryLimitDeath": koreanFieldName = "자손한도(사망)"; break;
                                case "bodilyInjuryDeductible": koreanFieldName = "대인면책금(인당)"; break;
                                case "propertyDamageDeductible": koreanFieldName = "대물면책금"; break;
                                case "personalInjuryDeductible": koreanFieldName = "자손면책금"; break;
                                default: koreanFieldName = "보험 금액"; break;
                            }

                            setFormData((prev) => ({
                                ...prev,
                                toastMsg: `${koreanFieldName}이 10억원을 초과합니다. 10억원 미만으로 수정해주세요.`
                            }));

                            // 자동 조정하지 않고 원래 값 유지
                            return value;
                        }
                        return value;
                    };

                    // 필요한 경우 데이터 변환 처리
                    updatedContract.contractInsuranceCondition = {
                        ...condition,
                        // selfCarLimitValue가 문자열인 경우 숫자로 변환
                        selfCarLimitValue: typeof condition.selfCarLimitValue === "string"
                            ? Number(uncomma(condition.selfCarLimitValue))
                            : condition.selfCarLimitValue,
                        // 빈 문자열이나 undefined인 경우 null로 변환하고 10억 미만 검증
                        selfCarIndemnityPrice: validateAmountRange(
                            condition.selfCarIndemnityPrice === "" ? null : condition.selfCarIndemnityPrice,
                            "selfCarIndemnityPrice"
                        ),
                        bodilyInjuryLimitPrice: validateAmountRange(
                            condition.bodilyInjuryLimitPrice === "" ? null : condition.bodilyInjuryLimitPrice,
                            "bodilyInjuryLimitPrice"
                        ),
                        propertyDamageLimitPrice: validateAmountRange(
                            condition.propertyDamageLimitPrice === "" ? null : condition.propertyDamageLimitPrice,
                            "propertyDamageLimitPrice"
                        ),
                        personalInjuryLimitInjury: validateAmountRange(
                            condition.personalInjuryLimitInjury === "" ? null : condition.personalInjuryLimitInjury,
                            "personalInjuryLimitInjury"
                        ),
                        personalInjuryLimitDeath: validateAmountRange(
                            condition.personalInjuryLimitDeath === "" ? null : condition.personalInjuryLimitDeath,
                            "personalInjuryLimitDeath"
                        ),
                        bodilyInjuryDeductible: validateAmountRange(
                            condition.bodilyInjuryDeductible === "" ? null : condition.bodilyInjuryDeductible,
                            "bodilyInjuryDeductible"
                        ),
                        propertyDamageDeductible: validateAmountRange(
                            condition.propertyDamageDeductible === "" ? null : condition.propertyDamageDeductible,
                            "propertyDamageDeductible"
                        ),
                        personalInjuryDeductible: validateAmountRange(
                            condition.personalInjuryDeductible === "" ? null : condition.personalInjuryDeductible,
                            "personalInjuryDeductible"
                        ),
                    };
                }

                return updatedContract;
            });
        }

        // 보험 관련 필드 처리
        if (Array.isArray(reqBody.insuranceItems)) {
            reqBody.insuranceItems = reqBody.insuranceItems.map((item) => ({
                ...item,
                imitType: item.imitType === "" ? null : item.imitType,
                compensationRange: item.compensationRange === "" ? null : item.compensationRange,
                selfPay: item.selfPay === "" ? null : item.selfPay,
                selfCarDamageRangeType: item.selfCarDamageRangeType === "" ? null : item.selfCarDamageRangeType,
                selfCarDamageRateType: item.selfCarDamageRateType === "" ? null : item.selfCarDamageRateType,
            }));
        }

        const toISOStringKST = (date) => {
            if (!date) return null;
            // date가 Date 객체라면
            if (typeof date === "object" && date instanceof Date) {
                // 그대로 toISOString() 사용 (Date 객체는 이미 로컬 기준)
                return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().slice(0, 19) + ".000Z";
            }
            // date가 문자열이면 Date 객체로 변환
            return new Date(date).toISOString().slice(0, 19) + ".000Z";
        };

        // buildRequestBody에서 변환
        if (Array.isArray(reqBody.contracts)) {
            reqBody.contracts = reqBody.contracts.map((contract) => {
                if (contract.allocation) {
                    return {
                        ...contract,
                        allocation: {
                            ...contract.allocation,
                            // releasedAt: toISOStringKST(contract.allocation.releasedAt),
                            // returnedAt: toISOStringKST(contract.allocation.returnedAt),
                        },
                    };
                }
                return contract;
            });
        }

        return reqBody;
    };

    // Validation 체크 함수
    const validateRegister = () => {
        // 필수 필드 검증 함수
        const validateField = (condition, message) => {
            if (condition) {
                setFormData((prev) => ({
                    ...prev,
                    toastMsg: message,
                }));
                return false;
            }
            return true;
        };

        // 문자열 필드 검증
        const validateStringField = (value, message) => {
            return validateField(!value || value.trim() === "", message);
        };

        // 주민번호 검증
        const validateIdNumber = (idNumberF, idNumberB, prefix, isRequired = true) => {
            if (isRequired) {
                if (!validateStringField(idNumberF, `${prefix} 주민번호 앞 6자리를 입력해주세요.`)) return false;
                if (!validateField(idNumberF.trim().length !== 6, `${prefix} 주민번호 앞자리는 6자리여야 합니다.`)) return false;
                if (!validateStringField(idNumberB, `${prefix} 주민번호 뒤 7자리를 입력해주세요.`)) return false;
                if (!validateField(idNumberB.trim().length !== 7, `${prefix} 주민번호 뒷자리는 7자리여야 합니다.`)) return false;
            }
            return true;
        };

        // 주소 검증
        const validateAddress = (address, addressDetail, prefix) => {
            if (!validateStringField(address, `${prefix} 주소를 입력해주세요.`)) return false;
            if (!validateStringField(addressDetail, `${prefix} 상세주소를 입력해주세요.`)) return false;
            return true;
        };

        // 운전자 정보 검증
        const validateDriver = (driver, prefix) => {
            if (!driver) return validateField(true, `${prefix} 정보를 입력해주세요.`);
            // if (!validateStringField(driver.name, `${prefix}명을 입력해주세요.`)) return false;
            if (!validateStringField(driver.phone, `${prefix} 연락처를 입력해주세요.`)) return false;
            // if (!validateIdNumber(driver.idNumberF, driver.idNumberB, prefix)) return false;
            // if (!validateAddress(driver.address, driver.addressDetail, prefix)) return false;
            return true;
        };

        // 3. 계약 유형 검증
        if (!validateStringField(formData.contractType, "계약 유형을 선택해주세요.")) return false;

        // 4. 계약자 정보 검증
        const mainDriver = formData.contracts[selectedContractIndex]?.contractDrivers?.find(
            (driver) => driver.contractDriverType === "MAIN"
        );
        if (!validateDriver(mainDriver, "계약자")) return false;

        // 5. 사고차량 정보 검증
        if (!formData.accidentCar) return validateField(true, "사고차량 정보를 입력해주세요.");
        if (!validateStringField(formData.accidentCar.carNumber, "사고차량 번호를 입력해주세요.")) return false;
        if (!validateStringField(formData.accidentCar.cho, "사고차량 국산/수입을 선택해주세요.")) return false;
        if (!validateStringField(formData.accidentCar.carGubun, "사고차량 차종을 선택해주세요.")) return false;
        if (!validateStringField(formData.accidentCar.bmNo, "사고차량 제조사를 입력해주세요.")) return false;
        if (!validateStringField(formData.accidentCar.boiNo, "사고차량 모델을 입력해주세요.")) return false;

        // 6. 계약 정보 및 계약차량 검증
        if (!formData.contracts || formData.contracts.length === 0) {
            return validateField(true, "계약 정보가 없습니다.");
        }

        for (const contract of formData.contracts) {
            if (!contract.contractCar) return validateField(true, "계약차량 정보가 누락되었습니다.");
            if (!validateStringField(contract.contractCar.carNumber, "계약차량 번호를 입력해주세요.")) return false;
            if (!validateStringField(contract.contractCar.manufacturerName, "계약차량 제조사를 입력해주세요.")) return false;
            if (!validateStringField(contract.contractCar.modelName, "계약차량 모델을 입력해주세요.")) return false;
        }

        // 7. 보험사 정보 검증
        if (!formData.contractInsurance) return validateField(true, "보험사 정보를 입력해주세요.");
        if (!validateStringField(formData.contractInsurance.insuranceCorpName, "보험사명을 입력해주세요.")) return false;
        // if (!validateStringField(formData.contractInsurance.receiptNumber, "접수번호를 입력해주세요.")) return false;

        // 제2운전자 정보 검증 (추가 운전자가 있는 경우)
        if (formData.contracts[selectedContractIndex]?.additionalDriverStatus) {
            const additionalDriver = formData.contracts[selectedContractIndex]?.contractDrivers?.find(
                (driver) => driver.contractDriverType === "ADDITIONAL"
            );
            if (!validateDriver(additionalDriver, "제2운전자")) return false;
        }

        // 12. 사업자 정보 검증 (사업자 정보가 있는 경우)
        if (formData.businessStatus) {
            if (!formData.contractBusinessInfo) return validateField(true, "사업자 정보를 입력해주세요.");
            if (!validateStringField(formData.contractBusinessInfo.corpName, "사업자 이름을 입력해주세요.")) return false;
            if (!validateStringField(formData.contractBusinessInfo.bizNumber, "사업자 번호를 입력해주세요.")) return false;
            if (!validateStringField(formData.contractBusinessInfo.managerName, "담당자 이름을 입력해주세요.")) return false;
            if (!validateStringField(formData.contractBusinessInfo.managerPhone, "담당자 연락처를 입력해주세요.")) return false;
            if (!validateStringField(formData.contractBusinessInfo.address, "사업자 주소를 입력해주세요.")) return false;

            const hasBizLic = formData.contractUploads?.some((item) => item.uploadType === "BIZ_LIC" && item.upload);
            if (!hasBizLic) return validateField(true, "사업자등록증 첨부파일을 첨부해주세요.");
        }

        return true;
    };

    const handleSubmit = async (action) => {
        setFormData((prev) => ({
            ...prev,
            isLoading: true,
            confirmStatus: { confirmPopupStatus: false },
        }));

        try {
            const requestBody = buildRequestBody();
            await action(requestBody);

            if (mode === "CREATE") {
                setFormData((prev) => ({
                    ...prev,
                    isLoading: false,
                    confirmStatus: {
                        confirmPopupStatus: true,
                        confirmTitle: "등록이 완료되었습니다.",
                        confirmDescription: "",
                        confirmButtons: [
                            {
                                label: "확인",
                                className: "btn-primary",
                                onClick: () => navigate("/contract/status"),
                            },
                        ],
                    },
                }));
            } else {
                setFormData((prev) => ({
                    ...prev,
                    toastMsg: "수정이 완료되었습니다.",
                    isLoading: false,
                }));
            }
        } catch (error) {
            setFormData((prev) => ({
                ...prev,
                toastMsg: error.message || "에러 발생",
                isLoading: false,
            }));
        } finally {
        }
    };

    // 차량 등록 시 호출 (CREATE)
    const handleSaveConfirm = async () => {
        try {
            setFormData((prev) => ({
                ...prev,
                isLoading: true,
                confirmStatus: { confirmPopupStatus: false },
            }));

            const requestBody = buildRequestBody();
            const response = await postContractGroup(requestBody).unwrap();

            // 기존 계약서들의 노출 상태를 "N"으로 변경
            if (passedOrderId && existingContractGroups.length > 0) {
                for (const group of existingContractGroups) {
                    await updateContractGroupExposedYn({
                        contractGroupId: group.id,
                        body: { exposedYn: "N" },
                    }).unwrap();
                }
            }

            setFormData((prev) => ({
                ...prev,
                isLoading: false,
                confirmStatus: {
                    confirmPopupStatus: true,
                    confirmTitle: "등록이 완료되었습니다.",
                    confirmDescription: "",
                    confirmButtons: [
                        {
                            label: "확인",
                            className: "btn-primary",
                            onClick: () => navigate("/contract/status"),
                        },
                    ],
                },
            }));
        } catch (error) {
            setFormData((prev) => ({
                ...prev,
                toastMsg: error.message || "에러 발생",
                isLoading: false,
            }));
        }
    };

    // 차량 수정 시 호출 (UPDATE)
    const handleUpdateConfirm = async () => {
        try {
            setFormData((prev) => ({
                ...prev,
                isLoading: true,
                confirmStatus: { confirmPopupStatus: false },
            }));

            const requestBody = buildRequestBody();
            await putContractGroup({ contractGroupId: formData.id, body: requestBody }).unwrap();

            // 기존 계약서들의 노출 상태를 "N"으로 변경 (현재 계약서 제외)
            if (passedOrderId && existingContractGroups.length > 0) {
                for (const group of existingContractGroups) {
                    if (group.id !== formData.id) {
                        await updateContractGroupExposedYn({
                            contractGroupId: group.id,
                            body: { exposedYn: "N" },
                        }).unwrap();
                    }
                }
            }

            setFormData((prev) => ({
                ...prev,
                toastMsg: "수정이 완료되었습니다.",
                isLoading: false,
            }));
        } catch (error) {
            setFormData((prev) => ({
                ...prev,
                toastMsg: error.message || "에러 발생",
                isLoading: false,
            }));
        }
    };

    const handleSave = () => {
        if (!validateRegister()) return;

        setFormData((prev) => ({
            ...prev,
            confirmStatus: {
                confirmPopupStatus: true,
                confirmTitle: `계약서 정보를 ${mode === "CREATE" ? "등록" : "수정"}하시겠습니까?`,
                confirmDescription: "",
                confirmButtons: [
                    { label: "예", className: "btn-primary", onClick: mode === "CREATE" ? handleSaveConfirm : handleUpdateConfirm },
                    {
                        label: "아니오",
                        className: "btn-cancel",
                        onClick: () =>
                            setFormData((prev2) => ({
                                ...prev2,
                                confirmStatus: { confirmPopupStatus: false },
                            })),
                    },
                ],
            },
        }));
    };

    useEffect(() => {
        if (postData) {
            setFormData((prev) => ({
                ...prev,
                confirmStatus: {
                    confirmPopupStatus: true,
                    confirmTitle: "등록이 완료되었습니다.",
                    confirmDescription: "",
                    confirmButtons: [
                        {
                            label: "확인",
                            className: "btn-primary",
                            onClick: () => navigate("/contract/status"),
                        },
                    ],
                },
            }));
        }
    }, [postData]);

    useEffect(() => {
        if (putData) {
            window.location.reload();
        }
    }, [putData]);

    const showConfirm = (title, description, buttons) => {
        setFormData((prev) => ({
            ...prev,
            confirmStatus: {
                confirmPopupStatus: true,
                confirmTitle: title,
                confirmDescription: description,
                confirmButtons: buttons,
            },
        }));
    };

    // 삭제 확인 핸들러 (API 호출)
    const handleDeleteConfirm = async () => {
        try {
            await deleteContractGroup({
                contractGroupId: formData.id,
            }).unwrap();
            showConfirm("삭제가 완료되었습니다.", "", [
                {
                    label: "확인",
                    className: "btn-primary",
                    onClick: () => navigate("/contract/status"),
                },
            ]);
        } catch (error) {
            console.error("Failed to delete contract:", error);
            setFormData((prev) => ({
                ...prev,
                toastMsg: error?.data?.message || "계약서 정보 삭제에 실패했습니다.",
            }));
        }
    };

    // 삭제 버튼 클릭 시 확인 모달을 띄우고, "예" 버튼 클릭 시 handleDeleteConfirm 실행
    const handleDelete = () => {
        showConfirm("해당 계약서 정보를 삭제하시겠습니까?", "삭제 후에는 복구할 수 없습니다.", [
            { label: "예", className: "btn-primary", onClick: handleDeleteConfirm },
            {
                label: "아니오",
                className: "btn-cancel",
                onClick: () =>
                    setFormData((prev) => ({
                        ...prev,
                        confirmStatus: { confirmPopupStatus: false },
                    })),
            },
        ]);
    };

    // 공통 파일 업로드 핸들러
    const handleCommonFileChange = async (e, uploadType, idx) => {
        const fileObj = e.target.files[0];
        if (!fileObj) return;

        setFormData((prev) => ({
            ...prev,
            isLoading: true,
        }));

        try {
            const formDataObj = new FormData();
            formDataObj.append("file", fileObj);
            const res = await uploadFile(formDataObj).unwrap();
            const newUploadId = res.data?.id || 0;
            setFormData((prev) => {
                // 만약 uploadType이 "ADD_TERM"이면, contractTerms[idx] 업데이트
                if (uploadType === "ADD_TERM") {
                    const updatedTerms = [...(prev.contractTerms || [])];
                    updatedTerms[idx] = {
                        ...updatedTerms[idx],
                        upload: { id: newUploadId },
                        fileName: fileObj.name,
                    };
                    return { ...prev, contractTerms: updatedTerms };
                }
                // 그 외: contractUploads 배열 업데이트
                const updatedUploads = [...(prev.contractUploads || [])];
                const index = updatedUploads.findIndex((x) => x.uploadType === uploadType);
                if (index >= 0) {
                    updatedUploads[index] = {
                        ...updatedUploads[index],
                        upload: { id: newUploadId, fileName: fileObj.name },
                    };
                } else {
                    updatedUploads.push({ uploadType, upload: { id: newUploadId, fileName: fileObj.name } });
                }
                return { ...prev, contractUploads: updatedUploads };
            });
        } catch (error) {
            console.error(error);
            setFormData((prev) => ({
                ...prev,
                toastMsg: error?.data?.message || "파일 업로드 실패",
            }));
        } finally {
            setFormData((prev) => ({
                ...prev,
                isLoading: false,
            }));
        }
    };

    const getTermFileName = (idx) => {
        return formData.contractTerms?.[idx]?.fileName || "";
    };

    const getFileName = (uploadType) => {
        const uploadObj = formData.contractUploads?.find((x) => x.uploadType === uploadType);
        return uploadObj?.upload?.fileName || "";
    };

    // 그룹 내 계약서 추가/삭제 핸들러
    const addContract = () => {
        setFormData((prev) => ({
            ...prev,
            contracts: [...prev.contracts, { ...initialContract }],
        }));
    };

    const deleteContract = (index) => {
        setFormData((prev) => ({
            ...prev,
            contracts: prev.contracts.filter((_, idx) => idx !== index),
        }));
    };

    // 약관 추가: mandatoryYn은 무조건 "Y"로 세팅, id는 임시 값(Date.now()) 사용 (실제 id는 서버에서 할당)
    const handleAddTerm = () => {
        setFormData((prev) => ({
            ...prev,
            contractTerms: [...(prev.contractTerms || []), { id: null, upload: { id: null }, name: "", mandatoryYn: "Y" }],
        }));
    };

    // 약관 선택 팝업
    const handleSelectTerms = () => {
        setFormData((prev) => ({ ...prev, termSelectPopupStatus: true }));
    };

    // Validation 체크 함수
    const validateCharge = () => {
        // 1. 청구방법(chargeMethod) 선택 여부 확인
        if (!formData.contractInsurance?.chargeMethod) {
            setFormData((prev) => ({
                ...prev,
                toastMsg: "청구방법을 선택해주세요.",
            }));
            return false;
        }
        // 2. 청구율(chargeRate) 선택 여부 확인
        if (!formData.contractInsurance?.chargeRate) {
            setFormData((prev) => ({
                ...prev,
                toastMsg: "청구율을 선택해주세요.",
            }));
            return false;
        }
        // 3. 모든 계약의 allocation?.releasedAt, allocation?.returnedAt 세팅 여부 확인
        if (!formData.contracts || formData.contracts.length === 0) {
            setFormData((prev) => ({
                ...prev,
                toastMsg: "계약 정보가 없습니다.",
            }));
            return false;
        }
        if (formData.mode !== "CREATE") {
            if (!formData.contractInsurance?.faxNumber) {
                setFormData((prev) => ({
                    ...prev,
                    toastMsg: "보험사 팩스번호를 입력해주세요.",
                }));
                return false;
            }
        }

        for (let contract of formData.contracts) {
            if (!contract.allocation?.releasedAt || !contract.allocation?.returnedAt) {
                setFormData((prev) => ({
                    ...prev,
                    toastMsg: "모든 계약의 대여일시와 반납일시를 설정해주세요.",
                }));
                return false;
            }
            // 4. 모든 계약에 billingInfo 객체가 존재하는지 확인
            if (!contract.billingInfo) {
                setFormData((prev) => ({
                    ...prev,
                    toastMsg: "모든 계약에 청구 정보가 설정되어 있어야 합니다.",
                }));
                return false;
            }
        }
        return true;
    };

    const handleShowFaxFile = (url) => {
        if (url) {
            window.open(url, "_blank");
        } else {
            setFormData((prev) => ({
                ...prev,
                toastMsg: "생성된 파일이 존재하지 않습니다.",
            }));
        }
    };

    // 청구하기 이벤트 핸들러
    const handleCharge = async () => {
        if (!validateCharge()) return;

        const chargeItems = formData.contracts.map((contract) => ({
            contractId: contract.id, // 계약 ID
            rentPriceTableItemId: contract.billingInfo?.rentPrice?.id || null, // 선택된 요금표 항목 ID
            baseRentPrice: Number(contract.billingInfo?.rentFee) || 0, // 기본 렌트료
            rentDays: contract.billingInfo?.days || 0, // 대여일 수
            rentHours: contract.billingInfo?.hours || 0, // 대여 시간
            chargeRate: formData.contractInsurance?.chargeRate || 0, // 청구율
            rentFee: Number(contract.billingInfo?.rentFee) || 0, // 실제 렌트료
            insuranceChargeFee: Number(contract.billingInfo?.insuranceChargeFee) || 0, // 보험 청구 금액
            platformCommissionFee: Number(contract.billingInfo?.platformCommissionFee) || 0, // 플랫폼 수수료
            exceptCommissionFee: Number(contract.billingInfo?.exceptCommissionFee) || 0, // 수수료 제외 금액
            exceptAddTaxFee: Number(contract.billingInfo?.exceptAddTaxFee) || 0, // 부가세 제외 금액
            orderCommissionFee: Number(contract.billingInfo?.orderCommissionFee) || 0, // 오더 업체 수수료
            obtainEarningFee: Number(contract.billingInfo?.obtainEarningFee) || 0, // 렌트카 수익
            allocation: {
                id: contract.allocation?.id || null,
                releasedAt: contract.allocation?.releasedAt || "",
                releaseMethod: contract.allocation?.releaseMethod || "",
                releaseAddress: contract.allocation?.releaseAddress || "",
                releaseAddressDetail: contract.allocation?.releaseAddressDetail || "",
                returnedAt: contract.allocation?.returnedAt || "",
                returnMethod: contract.allocation?.returnMethod || "",
                returnAddress: contract.allocation?.returnAddress || "",
                returnAddressDetail: contract.allocation?.returnAddressDetail || "",
                memo: contract.allocation?.memo || "",
            },
        }));

        // 전체 payload 구성
        const payload = {
            contractGroup: {
                id: formData.id, // 계약 그룹 ID
            },
            chargeItems,
            insuranceFaxNumber: formData.contractInsurance?.faxNumber,
        };

        try {
            setFormData((prev) => ({
                ...prev,
                isLoading: true,
            }));
            let res = await postCharge(payload).unwrap();
            setFormData((prev) => ({
                ...prev,
                toastMsg: "청구신청이 완료되었습니다.",
                isLoading: false,
                faxFileUrl: res.data.faxFileUrl || undefined,
                faxFileUploadId: res.data.faxFileUploadId || undefined,
            }));
        } catch (error) {
            setFormData((prev) => ({
                ...prev,
                toastMsg: error?.message || "청구하기 실패",
                isLoading: false,
            }));
        }
    };

    // 선청구하기 이벤트 핸들러
    const handlePreCharge = async () => {
        if (!validateCharge()) return;

        const chargeItems = formData.contracts.map((contract) => ({
            contractId: contract.id,
            rentPriceTableItemId: contract.billingInfo?.rentPrice?.id || null,
            baseRentPrice: Number(contract.billingInfo?.rentFee) || 0,
            rentDays: contract.billingInfo?.days || 0,
            rentHours: contract.billingInfo?.hours || 0,
            chargeRate: formData.contractInsurance?.chargeRate || 0,
            rentFee: Number(contract.billingInfo?.rentFee) || 0,
            insuranceChargeFee: Number(contract.billingInfo?.insuranceChargeFee) || 0,
            platformCommissionFee: Number(contract.billingInfo?.platformCommissionFee) || 0,
            exceptCommissionFee: Number(contract.billingInfo?.exceptCommissionFee) || 0,
            exceptAddTaxFee: Number(contract.billingInfo?.exceptAddTaxFee) || 0,
            orderCommissionFee: Number(contract.billingInfo?.orderCommissionFee) || 0,
            obtainEarningFee: Number(contract.billingInfo?.obtainEarningFee) || 0,
            allocation: {
                id: contract.allocation?.id || null,
                releasedAt: contract.allocation?.releasedAt || "",
                releaseMethod: contract.allocation?.releaseMethod || "",
                releaseAddress: contract.allocation?.releaseAddress || "",
                releaseAddressDetail: contract.allocation?.releaseAddressDetail || "",
                returnedAt: contract.allocation?.returnedAt || "",
                returnMethod: contract.allocation?.returnMethod || "",
                returnAddress: contract.allocation?.returnAddress || "",
                returnAddressDetail: contract.allocation?.returnAddressDetail || "",
                memo: contract.allocation?.memo || "",
            },
        }));

        const payload = {
            contractGroup: {
                id: formData.id,
            },
            chargeItems,
        };

        try {
            await postPreCharge(payload).unwrap();
            setFormData((prev) => ({
                ...prev,
                toastMsg: "선청구신청이 완료되었습니다.",
            }));
        } catch (error) {
            setFormData((prev) => ({
                ...prev,
                toastMsg: error?.message || "선청구하기 실패",
            }));
        }
    };

    const actionReturn = async (contractId, payload) => {
        try {
            await returnContract({
                contractGroupId: formData.id,
                contractId: contractId,
                body: payload,
            }).unwrap();

            setFormData((prev) => ({
                ...prev,
                toastMsg: "반납 등록이 완료되었습니다.",
                confirmStatus: { confirmPopupStatus: false },
            }));
        } catch (error) {
            setFormData((prev) => ({
                ...prev,
                toastMsg: error?.message || "반납 등록에 실패하였습니다.",
            }));
        }
    };

    // 반납 등록 버튼 이벤트 핸들러
    const handleReturnSubmit = async (contractId) => {
        const contract = formData.contracts.find((c) => c.id === contractId);
        if (!contract) {
            setFormData((prev) => ({
                ...prev,
                toastMsg: "해당 계약 정보를 찾을 수 없습니다.",
            }));
            return;
        }

        const allocation = contract.allocation || {};

        // 유효성 검사
        const validationFields = [
            { value: allocation.returnedAt, message: "반납일시를 입력해주세요." },
            // { value: allocation.returnMileage, message: "반납 주행거리를 입력해주세요.", isEmpty: (val) => val == null || val === "" },
            // { value: allocation.returnMethod, message: "반납 방법을 선택해주세요.", isEmpty: (val) => !val || val.trim() === "" },
            // { value: allocation.returnAddress, message: "반납 주소를 입력해주세요.", isEmpty: (val) => !val || val.trim() === "" },
            // {
            //     value: allocation.returnAddressDetail,
            //     message: "반납 주소 상세를 입력해주세요.",
            //     isEmpty: (val) => !val || val.trim() === "",
            // },
            // { value: allocation.returnGasAmount, message: "반납 주유량을 입력해주세요.", isEmpty: (val) => val == null || val === "" },
            { value: allocation.washStatus, message: "세차 상태를 선택해주세요.", isEmpty: (val) => !val || val.trim() === "" },
        ];

        for (const field of validationFields) {
            const isEmpty = field.isEmpty ? field.isEmpty(field.value) : !field.value;
            if (isEmpty) {
                setFormData((prev) => ({
                    ...prev,
                    toastMsg: field.message,
                }));
                return;
            }
        }

        // payload 생성: allocation 객체의 필요한 값들만 추출 (uncomma 함수 사용하여 숫자 값 처리)
        const payload = {
            returnedAt: convertUTCToLocal(new Date(allocation.returnedAt)),
            returnMileage: Number(uncomma(allocation.returnMileage)),
            returnMethod: allocation.returnMethod,
            returnAddress: allocation.returnAddress,
            returnAddressDetail: allocation.returnAddressDetail,
            returnGasAmount: allocation.returnGasAmount, // 필요 시 Number(uncomma())로 변환
            washStatus: allocation.washStatus,
        };

        setFormData((prev) => ({
            ...prev,
            isLoading: false,
            confirmStatus: {
                confirmPopupStatus: true,
                confirmTitle: "해당 계약 차량을 반납처리 하시겠습니까?",
                confirmDescription: "",
                confirmButtons: [
                    {
                        label: "확인",
                        className: "btn-primary",
                        onClick: () => actionReturn(contractId, payload),
                    },
                    {
                        label: "취소",
                        className: "btn-cancel",
                        onClick: () =>
                            setFormData((prev2) => ({
                                ...prev2,
                                confirmStatus: { confirmPopupStatus: false },
                            })),
                    },
                ],
            },
        }));
    };

    // 약관 목록 조회
    const shouldFetchTerms = !!formData.contracts[0]?.contractCar?.id && !!formData.contracts[0]?.rentCorpId;
    const { data: termListData } = useGetTermListQuery(shouldFetchTerms ? { rent_corp_id: formData.contracts[0]?.rentCorpId } : skipToken, {
        skip: !shouldFetchTerms,
    });
    // 약관 데이터 처리
    useEffect(() => {
        if (termListData?.data && mode === "CREATE") {
            const activeTerms = termListData.data.filter((term) => term.exposedYn === "Y");
            setFormData((prev) => ({
                ...prev,
                contractTerms: activeTerms?.map((term) => ({
                    termId: term.id,
                    name: term.name,
                    content: term.content,
                    checked: true,
                })),
            }));
        }
    }, [termListData, mode]);

    // 차량 이미지 업로드 이벤트 핸들러
    const handleImageUploadComplete = ({ uploadId, uploadType, contractIndex, index, imageType }) => {
        setFormData((prev) => {
            // contracts 배열 복사
            const updatedContracts = [...prev.contracts];

            // contractIndex가 유효한지 확인
            if (contractIndex === undefined || contractIndex === null) {
                console.error("Invalid contractIndex:", contractIndex);
                return prev;
            }

            // contract 객체가 존재하는지 확인
            if (!updatedContracts[contractIndex]) {
                console.error("Contract not found at index:", contractIndex);
                return prev;
            }

            // contract 객체 복사
            const updatedContract = { ...updatedContracts[contractIndex] };

            // carImages 배열이 없으면 초기화
            if (!updatedContract.carImages) {
                updatedContract.carImages = [];
            }

            // 이미지 추가
            updatedContract.carImages[index] = {
                upload: { id: uploadId },
                carImageType: imageType,
            };

            // contracts 배열 업데이트
            updatedContracts[contractIndex] = updatedContract;

            return {
                ...prev,
                contracts: updatedContracts,
            };
        });
    };

    // 차량 이미지 삭제 이벤트 핸들러
    const handleRemoveCarImage = (contractIndex, imageIndex) => {
        setFormData((prev) => {
            const updatedContracts = [...prev.contracts];
            const contract = updatedContracts[contractIndex];
            // carImages 배열을 새로 복사해서 해당 인덱스의 이미지만 제거
            const newCarImages = contract?.carImages ? [...contract.carImages] : [];
            newCarImages.splice(imageIndex, 1);
            updatedContracts[contractIndex] = {
                ...contract,
                carImages: newCarImages,
            };
            return {
                ...prev,
                contracts: updatedContracts,
            };
        });
    };

    // 차량 이미지 순서 변경 이벤트 핸들러
    const handleReorderCarImages = (contractIndex, reorderedImages) => {
        setFormData((prev) => {
            const updatedContracts = [...prev.contracts];
            const contract = updatedContracts[contractIndex];
            updatedContracts[contractIndex] = {
                ...contract,
                carImages: reorderedImages,
            };
            return {
                ...prev,
                contracts: updatedContracts,
            };
        });
    };

    const handleAdditionalDriverStatusChange = (e, contractIndex) => {
        setFormData((prev) => {
            const updatedContracts = [...prev.contracts];
            const contract = { ...updatedContracts[contractIndex] };

            if (e.target.checked) {
                // 추가 운전자가 없으면 새로운 배열을 생성하여 추가
                if (!contract.contractDrivers.some((d) => d.contractDriverType === "ADDITIONAL")) {
                    const newDriver = {
                        contractDriverType: "ADDITIONAL",
                        name: "",
                        idNumber: "",
                        phone: "",
                        address: "",
                        addressDetail: "",
                        bCode: "",
                        driverLicenseType: null,
                        driverLicenseNumber: null,
                        serialNumber: "",
                        issueDate: "",
                    };
                    contract.contractDrivers = [...contract.contractDrivers, newDriver];
                }
            } else {
                // 추가 운전자를 필터링하여 새로운 배열 생성
                contract.contractDrivers = contract?.contractDrivers?.filter((d) => d.contractDriverType !== "ADDITIONAL");
            }

            updatedContracts[contractIndex] = {
                ...contract,
                additionalDriverStatus: e.target.checked,
            };

            return {
                ...prev,
                contracts: updatedContracts,
            };
        });
    };

    // 운전면허증 파일 업로드 핸들러
    const handleDriverLicenseUpload = async (e, contractIndex, driverType) => {
        const file = e.target.files[0];
        if (!file) return;

        try {
            const formData = new FormData();
            formData.append("file", file);

            const response = await uploadFile(formData).unwrap();

            setFormData((prev) => {
                const updatedContracts = [...prev.contracts];
                const contract = { ...updatedContracts[contractIndex] };

                // 운전자 정보 업데이트
                contract.contractDrivers = contract?.contractDrivers?.map((driver) => {
                    if (driver.contractDriverType === driverType) {
                        return {
                            ...driver,
                            licenseFileId: response.data.id,
                            licenseFileName: file.name,
                        };
                    }
                    return driver;
                });

                updatedContracts[contractIndex] = contract;

                return {
                    ...prev,
                    contracts: updatedContracts,
                };
            });
        } catch (error) {
            setFormData((prev) => ({
                ...prev,
                toastMsg: "운전면허증 파일 업로드에 실패했습니다.",
            }));
        }
    };

    // 주소 검색 팝업 핸들러
    const handleAddressSearch = (contractIndex, driverType) => {
        setFormData((prev) => ({
            ...prev,
            addressPopupStatus: true,
            addressPopupTarget: `${driverType}_${contractIndex}`,
        }));
    };

    // 주소 설정 핸들러
    const handleSetAddress = (data) => {
        setFormData((prev) => {
            const [driverType, contractIndex] = prev.addressPopupTarget.split("_");
            const updatedContracts = [...prev.contracts];
            const contract = { ...updatedContracts[contractIndex] };

            // 운전자 정보 업데이트
            const updatedDrivers = contract.contractDrivers.map((driver) => {
                if (driver.contractDriverType === driverType) {
                    return {
                        ...driver,
                        address: data.address,
                        addressDetail: data.addressDetail,
                        bCode: data.bCode,
                    };
                }
                return driver;
            });

            updatedContracts[contractIndex] = {
                ...contract,
                contractDrivers: updatedDrivers,
            };

            return {
                ...prev,
                contracts: updatedContracts,
                addressPopupStatus: false,
                addressPopupTarget: null,
            };
        });
    };

    // 렌트 법인의 인감도장 확인 함수
    const checkCorpSeal = (rentCorp) => {
        if (rentCorp) {
            const hasCorpSeal = rentCorp.rentCorpUploads?.some((upload) => upload.uploadType === "CORP_SEAL");
            if (!hasCorpSeal) {
                // localStorage에서 해당 메시지 표시 여부 확인
                const dontShowCorpSealWarning = localStorage.getItem("dontShowCorpSealWarning");

                if (!dontShowCorpSealWarning) {
                    setFormData((prev) => ({
                        ...prev,
                        confirmStatus: {
                            confirmPopupStatus: true,
                            confirmTitle: "계약서 도장 이미지가 등록되지 않았습니다.",
                            confirmDescription:
                                "미등록 상태로 계약서를 " +
                                (mode === "CREATE" ? "생성" : "수정") +
                                " 하시겠습니까?\n(* 도장 및 서명 미등록으로 발생하는 법적 책임은 당사 모빌리카에 있지 않음을 안내드립니다.)",
                            confirmButtons: [
                                {
                                    label: "확인",
                                    className: "btn-primary",
                                    onClick: (data) => {
                                        // 체크박스가 선택된 경우 localStorage에 저장
                                        if (data?.dontShowAgain) {
                                            localStorage.setItem("dontShowCorpSealWarning", "true");
                                        }
                                        setFormData((prev2) => ({
                                            ...prev2,
                                            confirmStatus: { confirmPopupStatus: false },
                                        }));
                                    },
                                },
                            ],
                            showCheckbox: true,
                            checkboxLabel: "메시지 다시 띄우지 않기",
                        },
                    }));
                }
            }
        }
    };

    // 차량 선택 시 carId로 차량 정보만 세팅 (인감도장 체크는 VehicleListPopup에서 처리)
    const handleSearchCar = async (carId, contractIndex = 0) => {
        console.log(carId);
        setFormData((prev) => ({
            ...prev,
            isLoading: true,
        }));

        try {
            const res = await getCarById(carId).unwrap();
            const carData = res?.data;
            if (carData) {
                setFormData((prev) => {
                    const updatedContracts = [...prev.contracts];
                    updatedContracts[contractIndex] = {
                        ...updatedContracts[contractIndex],
                        contractCar: carData,
                        carId: carData.id,
                    };
                    return {
                        ...prev,
                        isLoading: false,
                        toastMsg: "차량 조회 완료",
                        contracts: updatedContracts,
                    };
                });

                // rentCorpApi를 통해 렌트 법인 정보 조회
                try {
                    const rentCorpRes = await fetchRentCorpByCarId(carId).unwrap();
                    checkCorpSeal(rentCorpRes?.data);
                } catch (error) {
                    console.error("렌트 법인 조회 에러:", error);
                }
            } else {
                throw new Error("차량 조회 실패");
            }
        } catch (error) {
            console.error("차량 조회 에러:", error);
            setFormData((prev) => ({
                ...prev,
                toastMsg: "차량 조회 실패",
                isLoading: false,
            }));
        }
    };

    // 법인 인감 체크를 위한 함수 (VehicleListPopup에 전달)
    const checkRentCorpSeal = async (vehicleData) => {
        try {
            // 선택된 차량 ID로 렌트 법인 정보 조회
            const rentCorpRes = await fetchRentCorpByCarId(vehicleData.id).unwrap();
            // 인감도장 체크
            checkCorpSeal(rentCorpRes?.data);
            // 차량 정보 업데이트는 VehicleListPopup의 onVehicleSelect에서 처리
        } catch (error) {
            console.error("렌트 법인 조회 에러:", error);
        }
    };

    // Toast 메시지 표시 함수
    const showToast = (message) => {
        setFormData((prev) => ({
            ...prev,
            toastMsg: message,
        }));
    };

    return (
        <>
            {toastMsg && <Toast visible={true} msg={toastMsg} setFormData={setFormData} />}

            <div className="management-form container">
                <div className="form-container">
                    <div className="form-head">
                        <div className="head-tit">
                            <span className="form_name">
                                {mode === "CREATE" ? "임대차 계약서 등록" : "임대차 계약서 상세"}{" "}
                                {formData.orderId && <span className="call-contract">CALL</span>}
                            </span>
                            <span className="form_desc"></span>
                        </div>
                        <div className="head-options">
                            {/* <button type="button" className="btn btn-outline" onClick={() => navigate(-1)}>
                                목록
                            </button>
                            {mode !== "CREATE" && (
                                <button type="button" className="btn btn-cancel" onClick={handleDelete}>
                                    계약서 삭제
                                </button>
                            )}
                            <button type="button" className="btn btn-save" onClick={handleSave}>
                                계약서 저장
                            </button> */}
                        </div>
                    </div>

                    <div className="form-content">
                        <div className="form-wrapper">
                            <div className="form-item">
                                <div className="item-head">
                                    <span className="form-item_tit">계약 유형</span>
                                    <div className="form-item_etc"></div>
                                </div>
                                <div className="item-body">
                                    <div className="item-list">
                                        <ContractInfo formData={formData} handleChange={handleChange} setFormData={setFormData} />
                                    </div>
                                </div>
                            </div>

                            {formData.businessStatus && (
                                <div className="form-item">
                                    <div className="item-head">
                                        <span className="form-item_tit">사업자 정보</span>
                                        <div className="form-item_etc"></div>
                                    </div>
                                    <div className="item-body">
                                        <div className="item-list">
                                            <BusinessInfo
                                                formData={formData}
                                                handleChange={handleChange}
                                                setFormData={setFormData}
                                                getFileName={getFileName}
                                                handleCommonFileChange={handleCommonFileChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="form-item">
                                <div className="item-head">
                                    <span className="form-item_tit">사고차량 정보</span>
                                    <div className="form-item_etc">
                                        <div className="checkbox">
                                            <input
                                                type="checkbox"
                                                id="businessStatus"
                                                name="businessStatus"
                                                checked={formData.businessStatus}
                                                onChange={(e) =>
                                                    setFormData((prev) => ({
                                                        ...prev,
                                                        businessStatus: e.target.checked,
                                                        contractBusinessInfo: e.target.checked ? prev.contractBusinessInfo : null,
                                                    }))
                                                }
                                            />
                                            <label htmlFor="businessStatus">사업자가 있습니다.</label>
                                        </div>

                                        <button
                                            type="button"
                                            className="btn btn-outline"
                                            onClick={() => {
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    orderListPopupStatus: true,
                                                }));
                                            }}
                                        >
                                            오더 불러오기
                                        </button>
                                    </div>
                                </div>
                                <div className="item-body">
                                    <div className="item-list">
                                        {/* AccidentInfo는 그룹 레벨의 accidentCar 사용 */}
                                        <AccidentInfo formData={formData} handleChange={handleChange} setFormData={setFormData} />
                                    </div>
                                </div>
                            </div>

                            {/* 그룹(계약서 그룹) 영역 – 계약 리스트 */}
                            <div className="form-group">
                                <div className="group-head">
                                    <div className="head-tit">계약 리스트</div>
                                    <div className="head-option"></div>
                                </div>

                                <div className="group-content">
                                    {formData.contracts.map((contract, idx) => (
                                        <div key={idx} className="group-item">
                                            <div className="group-item-head">
                                                <div className="head-tit">계약-{idx + 1}</div>
                                                <div className="head-option">
                                                    {mode !== "CREATE" && (
                                                        <>
                                                            {idx >= 1 && (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-cancel"
                                                                    onClick={() => deleteContract(idx)}
                                                                >
                                                                    계약 지우기
                                                                </button>
                                                            )}
                                                            {mode !== "CREATE" && (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-fourth"
                                                                    onClick={() => {
                                                                        const accessToken = localStorage.getItem("access_token");
                                                                        window.open(
                                                                            `${process.env.REACT_APP_SERVER_URL}/contract_group/${contractGroupId}/contract/${contract?.id}?btn_expose_yn=Y&token=${accessToken}`,
                                                                            "_blank"
                                                                        );
                                                                    }}
                                                                >
                                                                    계약서 보기
                                                                </button>
                                                            )}
                                                            <button
                                                                type="button"
                                                                className="btn btn-secondary"
                                                                onClick={() => {
                                                                    handleReturnSubmit(contract.id);
                                                                }}
                                                            >
                                                                반납 등록
                                                            </button>
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="group-item-body">
                                                <div className="form-item">
                                                    <div className="item-head">
                                                        <span className="form-item_tit">
                                                            운전자 정보 <i></i>
                                                        </span>
                                                        <div className="form-item_etc">
                                                            <div className="checkbox">
                                                                <input
                                                                    type="checkbox"
                                                                    id={`additionalDriverStatus-${selectedContractIndex}`}
                                                                    name="additionalDriverStatus"
                                                                    checked={
                                                                        formData.contracts[selectedContractIndex]?.additionalDriverStatus
                                                                    }
                                                                    onChange={(e) =>
                                                                        handleAdditionalDriverStatusChange(e, selectedContractIndex)
                                                                    }
                                                                />
                                                                <label htmlFor={`additionalDriverStatus-${selectedContractIndex}`}>
                                                                    제 2 운전자가 있습니다.
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="item-body">
                                                        <div className="item-list">
                                                            <DriverInfo
                                                                formData={formData}
                                                                handleChange={handleChange}
                                                                setFormData={setFormData}
                                                                getFileName={getFileName}
                                                                handleCommonFileChange={handleCommonFileChange}
                                                                contractIndex={selectedContractIndex}
                                                                handleDriverLicenseUpload={handleDriverLicenseUpload}
                                                                handleAddressSearch={handleAddressSearch}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                {formData.contracts[selectedContractIndex]?.additionalDriverStatus && (
                                                    <div className="form-item">
                                                        <div className="item-head">
                                                            <span className="form-item_tit">제 2 운전자 정보</span>
                                                            <div className="form-item_etc"></div>
                                                        </div>
                                                        <div className="item-body">
                                                            <div className="item-list">
                                                                <AdditionalDriverInfo
                                                                    formData={formData}
                                                                    handleChange={handleChange}
                                                                    setFormData={setFormData}
                                                                    getFileName={getFileName}
                                                                    handleCommonFileChange={handleCommonFileChange}
                                                                    contractIndex={selectedContractIndex}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                                <div className="form-item">
                                                    <div className="item-head">
                                                        <span className="form-item_tit">대여차량 정보</span>
                                                        <div className="form-item_etc"></div>
                                                    </div>
                                                    <div className="item-body">
                                                        <div className="item-list">
                                                            <VehicleInfo
                                                                contract={contract}
                                                                onContractChange={(newValues) => {
                                                                    setFormData((prev) => {
                                                                        const updated = [...prev.contracts];
                                                                        updated[idx] = {
                                                                            ...updated[idx],
                                                                            ...newValues,
                                                                        };
                                                                        return { ...prev, contracts: updated };
                                                                    });
                                                                }}
                                                                handleSearchCar={() => {
                                                                    setSelectedContractIndex(idx);
                                                                    handleSelectCar();
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="form-item">
                                                    <div className="item-head">
                                                        <span className="form-item_tit">대여차량 이미지</span>
                                                    </div>

                                                    <ImageUpload
                                                        maxImages={20}
                                                        labelText="이미지"
                                                        inputIdPrefix="car_images"
                                                        placeholderText="사진 업로드"
                                                        onUploadComplete={handleImageUploadComplete}
                                                        uploadType="carImages"
                                                        contractIndex={idx}
                                                        initialImages={contract.carImages || []}
                                                        onRemoveImage={(imageIndex) => handleRemoveCarImage(idx, imageIndex)}
                                                        onReorderImages={(reorderedImages) => handleReorderCarImages(idx, reorderedImages)}
                                                        imageType="RENT_CAR"
                                                    />
                                                </div>

                                                <div className="form-item">
                                                    <div className="item-head">
                                                        <span className="form-item_tit">배차/반납 정보</span>
                                                        <div className="form-item_etc"></div>
                                                    </div>
                                                    <div className="item-body">
                                                        <div className="item-list">
                                                            <ReturnInfo
                                                                formData={formData}
                                                                handleChange={handleChange}
                                                                setFormData={setFormData}
                                                                allocation={contract?.allocation}
                                                                onAllocationChange={(newValues) =>
                                                                    setFormData((prev) => {
                                                                        const updated = [...prev.contracts];
                                                                        updated[idx] = {
                                                                            ...updated[idx],
                                                                            allocation: { ...updated[idx].allocation, ...newValues },
                                                                        };
                                                                        return { ...prev, contracts: updated };
                                                                    })
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* 기존 insuranceItems가 있으면 기존 방식(InsuranceTable) 사용 */}
                                                {contract?.insuranceItems && contract.insuranceItems.length > 0 ? (
                                                    <div className="form-item">
                                                        <div className="item-head">
                                                            <span className="form-item_tit">보험 정보</span>
                                                            <div className="form-item_etc">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-outline"
                                                                    onClick={handleInsuranceConfigLoad}
                                                                >
                                                                    보험정보 불러오기
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className="item-body">
                                                            <div className="item-list">
                                                                <InsuranceTable
                                                                    insuranceItems={contract?.insuranceItems}
                                                                    onUpdateInsuranceItem={(index, newValues) =>
                                                                        setFormData((prev) => {
                                                                            const updated = [...prev.contracts];
                                                                            updated[idx] = {
                                                                                ...updated[idx],
                                                                                insuranceItems: updated[idx].insuranceItems?.map((item, i) =>
                                                                                    i === index ? { ...item, ...newValues } : item
                                                                                ),
                                                                            };
                                                                            return { ...prev, contracts: updated };
                                                                        })
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    /* 신규 등록이거나 새로운 방식으로 작성된 경우 새로운 3개 컴포넌트 사용 */
                                                    <>
                                                        <div className="form-item">
                                                            <div className="item-head">
                                                                <span className="form-item_tit">보험 정보 (일반 정보)</span>
                                                                <div className="form-item_etc">
                                                                    {/* <button
                                                                        type="button"
                                                                        className="btn btn-outline"
                                                                        onClick={handleInsuranceConfigLoad}
                                                                    >
                                                                        보험정보 불러오기
                                                                    </button> */}
                                                                </div>
                                                            </div>
                                                            <div className="item-body">
                                                                <div className="item-list">
                                                                    <InsuranceInfoNormal
                                                                        contractInsuranceCondition={contract?.contractInsuranceCondition}
                                                                        onUpdate={(field, value) =>
                                                                            setFormData((prev) => {
                                                                                const updated = [...prev.contracts];
                                                                                updated[idx] = {
                                                                                    ...updated[idx],
                                                                                    contractInsuranceCondition: {
                                                                                        ...updated[idx].contractInsuranceCondition,
                                                                                        [field]: value,
                                                                                    },
                                                                                };
                                                                                return { ...prev, contracts: updated };
                                                                            })
                                                                        }
                                                                        contractIndex={idx}
                                                                        showToast={showToast}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="form-item">
                                                            <div className="item-head">
                                                                <span className="form-item_tit">보험 정보 (자차 보험)</span>
                                                                <div className="form-item_etc"></div>
                                                            </div>
                                                            <div className="item-body">
                                                                <div className="item-list">
                                                                    <InsuranceInfoCar
                                                                        contractInsuranceCondition={contract?.contractInsuranceCondition}
                                                                        onUpdate={(field, value) =>
                                                                            setFormData((prev) => {
                                                                                const updated = [...prev.contracts];
                                                                                updated[idx] = {
                                                                                    ...updated[idx],
                                                                                    contractInsuranceCondition: {
                                                                                        ...updated[idx].contractInsuranceCondition,
                                                                                        [field]: value,
                                                                                    },
                                                                                };
                                                                                return { ...prev, contracts: updated };
                                                                            })
                                                                        }
                                                                        contractIndex={idx}
                                                                        showToast={showToast}
                                                                        isOrderCall={!!formData.orderId}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="form-item">
                                                            <div className="item-head">
                                                                <span className="form-item_tit">보험 정보 (종합 보험)</span>
                                                                <div className="form-item_etc"></div>
                                                            </div>
                                                            <div className="item-body">
                                                                <div className="item-list">
                                                                    <InsuranceInfoTotal
                                                                        contractInsuranceCondition={contract?.contractInsuranceCondition}
                                                                        onUpdate={(field, value) =>
                                                                            setFormData((prev) => {
                                                                                const updated = [...prev.contracts];
                                                                                updated[idx] = {
                                                                                    ...updated[idx],
                                                                                    contractInsuranceCondition: {
                                                                                        ...updated[idx].contractInsuranceCondition,
                                                                                        [field]: value,
                                                                                    },
                                                                                };
                                                                                return { ...prev, contracts: updated };
                                                                            })
                                                                        }
                                                                        contractIndex={idx}
                                                                        showToast={showToast}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                )}

                                                {mode !== "CREATE" && (
                                                    <div className="form-item">
                                                        <div className="item-head">
                                                            <span className="form-item_tit">청구 정보</span>
                                                        </div>
                                                        <div className="item-body">
                                                            <div className="item-list">
                                                                <BillingInfo
                                                                    formData={formData}
                                                                    setFormData={setFormData}
                                                                    contract={contract}
                                                                    onContractChange={(newValues) => {
                                                                        setFormData((prev) => {
                                                                            const updated = [...prev.contracts];
                                                                            updated[idx] = {
                                                                                ...updated[idx],
                                                                                billingInfo: { ...updated[idx].billingInfo, ...newValues },
                                                                            };
                                                                            return { ...prev, contracts: updated };
                                                                        });
                                                                    }}
                                                                    selectedContractIndex={selectedContractIndex}
                                                                    setSelectedContractIndex={setSelectedContractIndex}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="group-item-footer"></div>
                                        </div>
                                    ))}
                                </div>

                                {mode !== "CREATE" && (
                                    <>
                                        <div className="group-bottom">
                                            <div className="bottom-option">
                                                <button type="button" className="btn btn-sm btn-primary" onClick={addContract}>
                                                    계약 추가
                                                </button>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>

                            <div className="form-item">
                                <div className="item-head">
                                    <span className="form-item_tit">보험사 및 공업사 정보</span>
                                    <div className="form-item_etc"></div>
                                </div>
                                <div className="item-body">
                                    <div className="item-list">
                                        <InsuranceInfo formData={formData} handleChange={handleChange} setFormData={setFormData} />
                                    </div>
                                </div>
                            </div>

                            {/* {(mode !== "CREATE" || formData.orderId) && (
                                <div className="form-item">
                                    <div className="item-head">
                                        <span className="form-item_tit">종합 청구 정보</span>
                                        <div className="form-item_etc"></div>
                                    </div>
                                    <div className="item-body">
                                        <div className="item-list">
                                            <TotalBillingInfo formData={formData} handleChange={handleChange} setFormData={setFormData} />
                                        </div>
                                    </div>
                                    {mode !== "CREATE" && (
                                        <div className="item-bottom">
                                            <div className="bottom-option">
                                                <button type="button" className="btn btn-xs btn-primary" onClick={handleCharge}>
                                                    청구하기
                                                </button>
                                                <button type="button" className="btn btn-xs btn-secondary" onClick={handlePreCharge}>
                                                    선청구 하기
                                                </button>
                                                {formData.faxFileUrl ? (
                                                    <button
                                                        type="button"
                                                        className="btn btn-xs btn-secondary"
                                                        onClick={() => handleShowFaxFile(formData.faxFileUrl || "")}
                                                    >
                                                        청구 파일 미리보기
                                                    </button>
                                                ) : (
                                                    <></>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )} */}

                            <div className="form-item" style={{ display: "none" }}>
                                <div className="item-head">
                                    <span className="form-item_tit">기타 정보</span>
                                    <div className="form-item_etc"></div>
                                </div>
                                <div className="item-body">
                                    <div className="item-list">
                                        <OtherInfo formData={formData} handleChange={handleChange} setFormData={setFormData} />
                                    </div>
                                </div>
                            </div>

                            <div className="form-item">
                                <div className="item-head">
                                    <span className="form-item_tit">
                                        계약서 특약사항 <i>고객 계약서에 기재됩니다.</i>
                                    </span>
                                    <div className="form-item_etc"></div>
                                </div>
                                <div className="item-body">
                                    <div className="item-list">
                                        <OtherEtcInfo formData={formData} handleChange={handleChange} setFormData={setFormData} />
                                    </div>
                                </div>
                            </div>

                            <div className="form-item">
                                <div className="item-head">
                                    <span className="form-item_tit">
                                        메모 <i>계약 관련 메모를 입력하세요.</i>
                                    </span>
                                    <div className="form-item_etc"></div>
                                </div>
                                <div className="item-body">
                                    <div className="item-list">
                                        <EtcInfo formData={formData} handleChange={handleChange} setFormData={setFormData} />
                                    </div>
                                </div>
                            </div>

                            <div className="form-item" style={{ display: "none" }}>
                                <div className="item-head">
                                    <span className="form-item_tit">
                                        보험사 전달사항 <i>청구시 보험사에 전달됩니다.</i>
                                    </span>
                                    <div className="form-item_etc"></div>
                                </div>
                                <div className="item-body">
                                    <div className="item-list">
                                        <InsuranceDeliveredInfo formData={formData} handleChange={handleChange} setFormData={setFormData} />
                                    </div>
                                </div>
                            </div>

                            {formData.contracts[0].contractCar.id && (
                                <div className="form-item">
                                    <div className="item-head">
                                        <span className="form-item_tit">약관 확인</span>
                                        <div className="form-item_etc"></div>
                                    </div>
                                    <div className="item-body">
                                        <div className="item-list">
                                            <TermsTable formData={formData} handleChange={handleChange} setFormData={setFormData} />
                                        </div>
                                    </div>
                                    <div className="item-bottom">
                                        <div className="bottom-option">
                                            <button type="button" className="btn btn-xs btn-fourth" onClick={handleSelectTerms}>
                                                약관 선택
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="form-item">
                                <div className="item-head">
                                    <span className="form-item_tit">계약 관련 서류</span>
                                </div>
                                <div className="item-body">
                                    <div className="item-list">
                                        <AttachedFile
                                            formData={formData}
                                            handleChange={handleChange}
                                            setFormData={setFormData}
                                            getFileName={getFileName}
                                            handleCommonFileChange={handleCommonFileChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="form-button">
                        <div className="button-row">
                            <button type="button" className="btn btn-xs btn-outline" onClick={() => navigate(-1)}>
                                목록
                            </button>
                            {mode !== "CREATE" && (
                                <button type="button" className="btn btn-xs btn-cancel" onClick={handleDelete}>
                                    계약서 삭제
                                </button>
                            )}
                            <button type="button" className="btn btn-xs btn-primary" onClick={handleSave}>
                                계약서 저장
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Confirm 팝업 */}
            {confirmStatus.confirmPopupStatus && (
                <Confirm
                    layer={true}
                    onClose={() =>
                        setFormData((prev) => ({
                            ...prev,
                            confirmStatus: { confirmPopupStatus: false },
                        }))
                    }
                    title={confirmStatus.confirmTitle}
                    description={confirmStatus.confirmDescription}
                    buttons={confirmStatus.confirmButtons}
                    showCheckbox={confirmStatus.showCheckbox}
                    checkboxLabel={confirmStatus.checkboxLabel}
                />
            )}

            {/* 주소 검색 팝업 */}
            {addressPopupStatus && (
                <SearchAddress
                    modalStatus={addressPopupStatus}
                    setModalStatus={() =>
                        setFormData((prev) => ({
                            ...prev,
                            addressPopupStatus: false,
                            addressPopupTarget: null,
                        }))
                    }
                    setAddress={(data) =>
                        setFormData((prev) => {
                            const [driverType, contractIndex] = prev.addressPopupTarget.split("_");
                            const updatedContracts = [...prev.contracts];
                            const contract = updatedContracts[contractIndex];

                            // 운전자 정보 업데이트
                            const updatedDrivers = contract.contractDrivers.map((driver) => {
                                if (driver.contractDriverType === driverType) {
                                    return {
                                        ...driver,
                                        address: data.address,
                                        addressDetail: data.addressDetail,
                                        bCode: data.bCode,
                                    };
                                }
                                return driver;
                            });

                            updatedContracts[contractIndex] = {
                                ...contract,
                                contractDrivers: updatedDrivers,
                            };

                            return {
                                ...prev,
                                contracts: updatedContracts,
                                addressPopupStatus: false,
                                addressPopupTarget: null,
                            };
                        })
                    }
                />
            )}

            {agentPartnersPopupStatus && (
                <AgentPartnersPopup
                    layer={true}
                    onClose={() => setFormData((prev) => ({ ...prev, agentPartnersPopupStatus: false }))}
                    formData={formData.productItemType}
                    handleChange={handleChange}
                    setFormData={setFormData}
                    onAgentPartnerSelect={(partnerData) => {
                        // setFormData((prev) => {
                        //     const updated = [...prev.contracts];
                        //     updated[selectedContractIndex] = {
                        //         ...updated[selectedContractIndex],
                        //         contractCar: carData,
                        //         carId: carData.id,
                        //     };
                        //     return { ...prev, contracts: updated };
                        // });
                    }}
                />
            )}

            {salesPartnersPopupStatus && (
                <SalesPartnersPopup
                    layer={true}
                    onClose={() => setFormData((prev) => ({ ...prev, salesPartnersPopupStatus: false }))}
                    formData={formData.productItemType}
                    handleChange={handleChange}
                    setFormData={setFormData}
                    onSalesPartnerSelect={(partnerData) => {
                        // setFormData((prev) => {
                        //     const updated = [...prev.contracts];
                        //     updated[selectedContractIndex] = {
                        //         ...updated[selectedContractIndex],
                        //         contractCar: carData,
                        //         carId: carData.id,
                        //     };
                        //     return { ...prev, contracts: updated };
                        // });
                    }}
                />
            )}

            {formData.vehicleListPopupStatus && (
                <VehicleListPopup
                    layer={true}
                    onClose={() => setFormData((prev) => ({ ...prev, vehicleListPopupStatus: false }))}
                    setFormData={setFormData}
                    rentCorpId={formData.contracts[selectedContractIndex].rentCorpId}
                    onRentCorpSelect={(value) => {
                        setFormData((prev) => {
                            const updated = [...prev.contracts];
                            updated[selectedContractIndex] = {
                                ...updated[selectedContractIndex],
                                rentCorpId: value,
                            };
                            return { ...prev, contracts: updated };
                        });
                    }}
                    onVehicleSelect={(vehicleData) => {
                        getCarById(vehicleData.id)
                            .then((res) => {
                                const carData = res.data?.data;
                                setFormData((prev) => {
                                    const updated = [...prev.contracts];
                                    updated[selectedContractIndex] = {
                                        ...updated[selectedContractIndex],
                                        contractCar: carData,
                                        carId: carData.id,
                                        // insuranceItems: carData?.insurance?.insuranceItems, // 신규 등록 시 새로운 보험 정보 구조 사용을 위해 주석처리
                                    };
                                    return { ...prev, contracts: updated };
                                });
                                // 차량 선택 시 법인 인감 체크
                                checkRentCorpSeal(vehicleData);
                            })
                            .catch((error) => {
                                console.error("차량 조회 에러:", error);
                            });
                    }}
                />
            )}

            {formData.termSelectPopupStatus && (
                <TermListPopup
                    layer={true}
                    onClose={() => setFormData((prev) => ({ ...prev, termSelectPopupStatus: false }))}
                    formData={formData}
                    handleChange={handleChange}
                    setFormData={setFormData}
                    onTermsSelect={(selectedTermsData) => {
                        setFormData((prev) => ({
                            ...prev,
                            contractTerms: selectedTermsData,
                        }));
                    }}
                />
            )}

            {formData.orderListPopupStatus && (
                <OrderListPopup
                    layer={true}
                    onClose={() => setFormData((prev) => ({ ...prev, orderListPopupStatus: false }))}
                    formData={formData}
                    handleChange={handleChange}
                    setFormData={setFormData}
                    onOrderSelect={(order) => {
                        loadOrderDetail(order.id);
                    }}
                />
            )}

            {vehicleReturnPopupStatus && (
                <VehicleReturnPopup
                    layer={true}
                    onClose={() => setFormData((prev) => ({ ...prev, vehicleReturnPopupStatus: false, vehicleReturnContractIdx: null }))}
                    formData={formData}
                    handleChange={handleChange}
                    setFormData={setFormData}
                />
            )}

            {billingSettingPopupStatus && (
                <BillingSettingPopup
                    layer={true}
                    onClose={() => {
                        setFormData((prev) => ({
                            ...prev,
                            billingSettingPopupStatus: false,
                        }));
                        setSelectedContractIndex(null);
                    }}
                    formData={formData}
                    handleChange={handleChange}
                    setFormData={setFormData}
                    selectedContractIndex={selectedContractIndex}
                />
            )}
            {insuranceConfigPopupStatus && (
                <InsuranceConfigPopup
                    layer={true}
                    onClose={() => setInsuranceConfigPopupStatus(false)}
                    formData={formData}
                    setFormData={setFormData}
                    onInsuranceConfigSelect={(config) => {
                        setSelectedInsuranceConfigId(config.id);
                        setFormData((prev) => {
                            const newContracts = [...prev.contracts];
                            newContracts[selectedContractIndex] = {
                                ...newContracts[selectedContractIndex],
                                rentCorpId: config.rentCorpId,
                            };
                            return {
                                ...prev,
                                contracts: newContracts,
                            };
                        });
                    }}
                />
            )}
        </>
    );
};
